// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type StaticUrlResponse,
  StaticUrlResponseFromJSON,
  StaticUrlResponseToJSON,
} from "../models/StaticUrlResponse";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface PublicStaticFileRequest {
  /**
   *
   */
  filePath: string;
}

/**
 *
 */
export class StaticFilesApi extends runtime.BaseAPI {
  /**
   * Creates request options for publicStaticFile without sending the request
   */
  async publicStaticFileRequestOpts(
    requestParameters: PublicStaticFileRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["filePath"] == null) {
      throw new runtime.RequiredError(
        "filePath",
        'Required parameter "filePath" was null or undefined when calling publicStaticFile().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/static-file/{file_path}`;
    urlPath = urlPath.replace(
      "{file_path}",
      encodeURIComponent(String(requestParameters["filePath"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Retrieve public static files, requires authorization, but no tenant context.
   * Get a public static file
   */
  async publicStaticFileRaw(
    requestParameters: PublicStaticFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<StaticUrlResponse>> {
    const requestOptions = await this.publicStaticFileRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StaticUrlResponseFromJSON(jsonValue)
    );
  }

  /**
   * Retrieve public static files, requires authorization, but no tenant context.
   * Get a public static file
   */
  async publicStaticFile(
    requestParameters: PublicStaticFileRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<StaticUrlResponse> {
    const response = await this.publicStaticFileRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
